/**
 * Mobile-app entry gate.
 *
 * On phone-sized screens Landoo behaves like an app: the first screen is always
 * Login / Register and the map only appears after sign-in. On tablet and
 * desktop the map stays a public landing page, so this renders nothing there.
 */

import { Link } from "@tanstack/react-router";
import { AppLogo } from "./AppLogo";
import { useAuth } from "@/lib/auth";
import { useIsMobile } from "@/hooks/use-mobile";

export function useMobileAuthWall() {
  const isMobile = useIsMobile();
  const { user, loading } = useAuth();
  return { blocked: isMobile && !loading && !user, checking: isMobile && loading };
}

export function MobileAuthGate() {
  return (
    <div className="flex min-h-[100dvh] flex-col justify-between bg-cream/40 px-6 pb-8 pt-14">
      <div>
        <AppLogo />
        <h1 className="mt-8 text-2xl font-bold text-brown-dark">
          Find your next place on the map.
        </h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Sign in to browse properties, parking and land near you, save favourites and contact
          owners.
        </p>
      </div>

      <div className="space-y-3">
        <Link
          to="/login"
          className="block w-full rounded-xl bg-coral py-3 text-center text-sm font-semibold text-white shadow-soft transition hover:brightness-105"
        >
          Sign in
        </Link>
        <Link
          to="/register"
          className="block w-full rounded-xl border border-border bg-background py-3 text-center text-sm font-semibold text-brown-dark shadow-soft transition hover:bg-brand-soft"
        >
          Create an account
        </Link>
        <p className="pt-2 text-center text-[11px] text-muted-foreground">
          Landoo · GPS-first property discovery
        </p>
      </div>
    </div>
  );
}
